import Header from '../Header/Header'
import * as S from './Page.styles'
import { useSelector } from 'src/utils/store'
import { useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { initialState } from 'src/features/transfers/TransfersState'

interface PageProps {
  children: React.ReactNode;
  headerTitle: string;
  notRedirect?: boolean;
}

const Page: React.FC<PageProps> = ({
  children, headerTitle, notRedirect = false,
}) => {
  const { receiveUser } = useSelector((state) => state.transfers)
  const history = useHistory()

  useEffect(() => {
    if (!notRedirect && receiveUser === initialState.receiveUser) {
      history.push('/transfers/receive')
    }
  }, [history, notRedirect, receiveUser])

  return (
    <S.PageContainer>
      <Header
        title={headerTitle}
      />
      {children}
    </S.PageContainer>
  )
}

export default Page
